'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ClaimsListItem = require('../ClaimsListItem.js');
var nthBitHeader = require('@narvar/nth-bit-header');
var ClaimsList_module = require('./ClaimsList.module.css.js');
var Box = require('../../../../../common/components/layout/Box/Box.js');
var index = require('../../../../../common/components/Icon/index.js');
var SessionContext = require('../../../../../common/providers/SessionContext.js');
var EmptyResults = require('./EmptyResults/EmptyResults.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimsList = _ref => {
  let {
    claims
  } = _ref;
  const {
    caseNumber
  } = SessionContext.useSession();
  const {
    claimsOrderClaimsNoClaimsOnOrder,
    claimsOrderClaimsListHeaderInCase,
    claimsOrderClaimsListHeaderNotInCase,
    claimsOrderClaimsListNoClaimsInCase
  } = nthHookTranslations.useTranslations();
  const {
    inCase,
    notInCase
  } = (claims ?? []).reduce((acc, claim) => {
    if (claim.referenceNumber === caseNumber) {
      acc.inCase.push(claim);
    } else {
      acc.notInCase.push(claim);
    }
    return acc;
  }, {
    inCase: [],
    notInCase: []
  });
  if (!(claims !== null && claims !== void 0 && claims.length)) {
    return /*#__PURE__*/React__default["default"].createElement(EmptyResults["default"], null, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      gap: 2,
      style: {
        justifyItems: 'center'
      }
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      icon: "Folder"
    }), claimsOrderClaimsNoClaimsOnOrder));
  }
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: 'h2'
  }, claimsOrderClaimsListHeaderInCase), inCase.length > 0 ? /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "ul",
    gap: 3,
    className: ClaimsList_module["default"].claimsList
  }, inCase.map(claim => /*#__PURE__*/React__default["default"].createElement(ClaimsListItem["default"], {
    key: claim.id,
    claim: claim
  }))) : /*#__PURE__*/React__default["default"].createElement(EmptyResults["default"], null, claimsOrderClaimsListNoClaimsInCase)), notInCase.length > 0 && /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: 'h2'
  }, claimsOrderClaimsListHeaderNotInCase), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "ul",
    gap: 3,
    className: ClaimsList_module["default"].claimsList
  }, notInCase.map(claim => /*#__PURE__*/React__default["default"].createElement(ClaimsListItem["default"], {
    key: claim.id,
    claim: claim
  })))));
};
var ClaimsList$1 = nthHookTranslations.withTranslationsProvider(ClaimsList, {
  translationKeys: ['claimsOrderClaimsNoClaimsOnOrder', 'claimsOrderClaimsListHeaderInCase', 'claimsOrderClaimsListHeaderNotInCase', 'claimsOrderClaimsListNoClaimsInCase']
});

exports["default"] = ClaimsList$1;
